<template>
  <div>
    <my-header-view
      icon="mdi-storefront-plus-outline"
      :title="'Crear establecimiento'"
    />
    <v-row class="my-2">
      <v-col v-if="inProgressSuccess">
        <v-card flat class="soft_shadow">
          <v-card-text>
            <v-row class="py-5">
              <v-col cols="12 d-flex items-center justify-center">
                <div class="py-12">
                  <div class="pb-4">
                    <v-img
                      :max-height="$vuetify.breakpoint.mdAndDown ? 150 : 200"
                      contain
                      src="/img/nube-success.png"
                      position="center"
                    >
                    </v-img>
                  </div>
                  <h1 class="primary--text text-center">
                    ¡Su establecimiento esta siendo creado!
                  </h1>
                  <p class="pt-5 font-weight-bold">
                    Estamos configurando todo lo necesario para que puedas usar
                    el nuevo establecimiento. Este proceso puede tardar unos
                    minutos.
                  </p>
                  <p class="font-weight-bold">
                    Mientras tanto, puedes seguir navegando por el sistema o
                    cerrar sesión para cambiar de establecimiento.
                  </p>
                  <div class="pt-4">
                    <v-row justify="center">
                      <v-col cols="6">
                        <div>
                          <v-btn
                            @click="gotoRoute('Home')"
                            color="primary"
                            elevation="0"
                            block
                            large
                            outlined
                          >
                            <div>
                              Continuar navegando
                              <v-icon dark> mdi-home-variant-outline </v-icon>
                            </div>
                          </v-btn>
                        </div>
                        <div class="pt-4">
                          <v-btn
                            @click="logout"
                            color="primary"
                            elevation="0"
                            block
                            large
                          >
                            <div>
                              <v-icon left dark>mdi-logout </v-icon>
                              Salir y utilizar nuevo establecimiento
                            </div>
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-else cols="12">
        <v-card flat class="soft_shadow">
          <v-card-text>
            <v-row class="py-5">
              <v-col
                cols="12"
                md="12"
                lg="10"
                class="px-md-16 px-lg-1 offset-lg-1"
              >
                <v-col cols="12" class="py-5">
                  <v-alert
                    :icon="'mdi-lightbulb-on-outline'"
                    prominent
                    text
                    color="primary"
                    dense
                  >
                    Recuerda llenar todos los datos, conforme se solicita.
                  </v-alert>
                </v-col>
              </v-col>
              <v-col cols="12" class="px-md-16">
                <v-form ref="form" lazy-validation @submit.prevent="save">
                  <v-row>
                    <v-col cols="12">
                      <h3 class="my_battery_blue--text">
                        Datos del Usuario Administrador
                      </h3>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="colForm">
                      <v-text-field
                        label="Email (Usuario Administrador)"
                        required
                        outlined
                        dense
                        background-color="white"
                        v-model="data.usuEmail"
                        :rules="emailRules"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="colForm">
                      <v-text-field
                        label="Contraseña"
                        required
                        outlined
                        dense
                        background-color="white"
                        v-model="data.usuPassword"
                        :rules="noEmptyRules"
                        :type="showPassword ? 'text' : 'password'"
                        :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                        @click:append="() => (showPassword = !showPassword)"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="colForm">
                      <v-text-field
                        label="Nombre ( usuario administrador)"
                        required
                        outlined
                        dense
                        background-color="white"
                        v-model="data.usuNombre"
                        :rules="noEmptyRules"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="colForm mb-4">
                      <h3 class="my_battery_blue--text">Datos de la Empresa</h3>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="colForm">
                      <v-select
                        :items="paisItems"
                        label="País"
                        item-text="name"
                        item-value="code"
                        outlined
                        dense
                        background-color="white"
                        v-model="data.paiIso"
                        @change="handleChangePaiIso()"
                      ></v-select>
                    </v-col>
                    <v-col
                      v-if="$vuetify.breakpoint.mdAndUp"
                      cols="12"
                      sm="6"
                      md="6"
                      class="colForm"
                    >
                    </v-col>
                    <v-col v-if="data.paiIso" cols="12" class="px-0 mx-0">
                      <v-row no-gutters class="px-0 mx-0">
                        <v-col cols="12" sm="6" class="colForm">
                          <v-text-field
                            label="Nit"
                            required
                            outlined
                            dense
                            background-color="white"
                            v-model="data.estNit"
                            :rules="nitRules"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          v-if="validateCountry(['SLV'])"
                          cols="12"
                          sm="6"
                          class="colForm"
                        >
                          <v-text-field
                            label="NRC"
                            required
                            outlined
                            dense
                            background-color="white"
                            v-model="data.estNrc"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="6" class="colForm">
                          <v-text-field
                            label="Razón Social"
                            required
                            outlined
                            dense
                            background-color="white"
                            v-model="data.estRazon"
                            :rules="noEmptyRules"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" class="colForm">
                          <v-text-field
                            label="Nombre Comercial"
                            required
                            outlined
                            dense
                            background-color="white"
                            v-model="data.estNombre"
                            :rules="noEmptyRules"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" class="colForm">
                          <v-text-field
                            label="Nombre del establecimiento(Siglas)"
                            required
                            outlined
                            dense
                            background-color="white"
                            v-model="data.estSiglas"
                            :rules="noEmptyRules"
                            hint="Ej: empresa azul - 02"
                          >
                            <template v-slot:append-outer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-icon v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                Nombre del establecimiento dentro del sistema.
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" class="colForm">
                          <v-select
                            :items="ItemsTipoProducto"
                            label="Tipo empresa"
                            item-text="name"
                            item-value="code"
                            outlined
                            dense
                            background-color="white"
                            v-model="data.estProducto"
                          ></v-select>
                        </v-col>
                        <!--email-->
                        <v-col
                          v-if="validateCountry(['SLV'])"
                          cols="12"
                          sm="6"
                          class="colForm"
                        >
                          <v-text-field
                            label="Email para anulaciones FEL"
                            required
                            outlined
                            dense
                            background-color="white"
                            v-model="data.estEmail"
                            :rules="emailRules"
                          >
                            <template v-slot:append-outer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-icon v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                Se necesita un email para realizar anulaciones
                                de facturas en el establecimiento.
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col
                          v-if="validateCountry(['SLV'])"
                          cols="12"
                          class="colForm mb-4"
                        >
                          <h4 class="support--text">Actividades economicas</h4>
                        </v-col>
                        <!--actividades economicas-->
                        <v-col
                          v-if="validateCountry(['SLV'])"
                          cols="12"
                          sm="6"
                          md="6"
                          class="colForm"
                        >
                          <v-autocomplete
                            messages="Busca por código, abreviatura o nombre"
                            :items="actividadesEconomicasItems"
                            v-model="data.craecId"
                            :filter="actividadEconomicaFilter"
                            item-text="scrm_craec_nombre"
                            item-value="scrm_craec_id"
                            label="Actividad económica 1"
                            dense
                            outlined
                            no-data-text="No se encontraron registros."
                            clearable
                            :loader-height="5"
                            :loading="loadingActividadEconomicaItems"
                            :disabled="loadingActividadEconomicaItems"
                            :rules="noEmptyRules"
                          >
                            <template v-slot:selection="data">
                              <small>
                                {{ data.item.scrm_craec_nombre }}
                              </small>
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <small class="font-weight-bold">
                                      {{ data.item.scrm_craec_nombre }}
                                    </small>
                                    <v-chip
                                      x-small
                                      color="primary lighten-4"
                                      class="
                                        primary--text
                                        text--darken-2
                                        float-right
                                        d-flex
                                        align-center,
                                      "
                                    >
                                      {{ data.item.scrm_craec_abreviatura }}
                                    </v-chip>
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    <small>
                                      <span class="font-weight-bold"
                                        >código:</span
                                      >
                                      {{ data.item.scrm_craec_codigo }}
                                    </small>
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col
                          v-if="validateCountry(['SLV'])"
                          cols="12"
                          sm="6"
                          md="6"
                          class="colForm"
                        >
                          <v-autocomplete
                            messages="Busca por código, abreviatura o nombre"
                            :items="actividadesEconomicasItems"
                            v-model="data.craecId2"
                            :filter="actividadEconomicaFilter"
                            item-text="scrm_craec_nombre"
                            item-value="scrm_craec_id"
                            label="Actividad económica 2"
                            dense
                            outlined
                            no-data-text="No se encontraron registros."
                            clearable
                            :loader-height="5"
                            :loading="loadingActividadEconomicaItems"
                            :disabled="loadingActividadEconomicaItems"
                          >
                            <template v-slot:selection="data">
                              <small>
                                {{ data.item.scrm_craec_nombre }}
                              </small>
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <small class="font-weight-bold">
                                      {{ data.item.scrm_craec_nombre }}
                                    </small>
                                    <v-chip
                                      x-small
                                      color="primary lighten-4"
                                      class="
                                        primary--text
                                        text--darken-2
                                        float-right
                                        d-flex
                                        align-center,
                                      "
                                    >
                                      {{ data.item.scrm_craec_abreviatura }}
                                    </v-chip>
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    <small>
                                      <span class="font-weight-bold"
                                        >código:</span
                                      >
                                      {{ data.item.scrm_craec_codigo }}
                                    </small>
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col
                          v-if="validateCountry(['SLV'])"
                          cols="12"
                          sm="6"
                          md="6"
                          class="colForm"
                        >
                          <v-autocomplete
                            messages="Busca por código, abreviatura o nombre"
                            :items="actividadesEconomicasItems"
                            v-model="data.craecId3"
                            :filter="actividadEconomicaFilter"
                            item-text="scrm_craec_nombre"
                            item-value="scrm_craec_id"
                            label="Actividad económica 3"
                            dense
                            outlined
                            no-data-text="No se encontraron registros."
                            clearable
                            :loader-height="5"
                            :loading="loadingActividadEconomicaItems"
                            :disabled="loadingActividadEconomicaItems"
                          >
                            <template v-slot:selection="data">
                              <small>
                                {{ data.item.scrm_craec_nombre }}
                              </small>
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <small class="font-weight-bold">
                                      {{ data.item.scrm_craec_nombre }}
                                    </small>
                                    <v-chip
                                      x-small
                                      color="primary lighten-4"
                                      class="
                                        primary--text
                                        text--darken-2
                                        float-right
                                        d-flex
                                        align-center,
                                      "
                                    >
                                      {{ data.item.scrm_craec_abreviatura }}
                                    </v-chip>
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    <small>
                                      <span class="font-weight-bold"
                                        >código:</span
                                      >
                                      {{ data.item.scrm_craec_codigo }}
                                    </small>
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col
                          v-if="validateCountry(['SLV'])"
                          cols="12"
                          class="colForm mb-4"
                        >
                          <h4 class="support--text">Ubicación</h4>
                        </v-col>
                        <v-col
                          v-if="validateCountry(['SLV'])"
                          cols="12"
                          sm="4"
                          md="4"
                          class="colForm"
                        >
                          <v-autocomplete
                            @change="handleChangeDepartamento()"
                            messages="Busca por código o nombre"
                            :items="departamentosItems"
                            v-model="data.addepId"
                            :filter="departamentoFilter"
                            item-text="sadm_addep_nombre"
                            item-value="sadm_addep_id"
                            label="Departamento"
                            dense
                            outlined
                            no-data-text="No se encontraron registros."
                            clearable
                            :loader-height="5"
                            :loading="departamentosLoading"
                            :disabled="departamentosLoading"
                            :rules="noEmptyRules"
                          >
                            <template v-slot:selection="data">
                              <small>
                                {{ data.item.sadm_addep_nombre }}
                              </small>
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <small class="font-weight-bold">
                                      {{ data.item.sadm_addep_nombre }}
                                    </small>
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    <small>
                                      <span class="font-weight-bold"
                                        >código:</span
                                      >
                                      {{ data.item.sadm_addep_codigo }}
                                    </small>
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col
                          v-if="validateCountry(['SLV'])"
                          cols="12"
                          sm="4"
                          md="4"
                          class="colForm"
                        >
                          <v-autocomplete
                            @change="handleChangeMunicipio()"
                            messages="Busca por código o nombre"
                            :items="municipiosItems"
                            v-model="data.admunId"
                            :filter="municipioFilter"
                            item-text="sadm_admun_nombre"
                            item-value="sadm_admun_id"
                            label="Municipio"
                            dense
                            outlined
                            no-data-text="No se encontraron registros."
                            clearable
                            :loader-height="5"
                            :loading="municipiosLoading"
                            :disabled="municipiosLoading"
                            :rules="noEmptyRules"
                          >
                            <template v-slot:selection="data">
                              <small>
                                {{ data.item.sadm_admun_nombre }}
                              </small>
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <small class="font-weight-bold">
                                      {{ data.item.sadm_admun_nombre }}
                                    </small>
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    <small>
                                      <span class="font-weight-bold"
                                        >código:</span
                                      >
                                      {{ data.item.sadm_admun_codigo }}
                                    </small>
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col
                          v-if="validateCountry(['SLV'])"
                          cols="12"
                          sm="4"
                          md="4"
                          class="colForm"
                        >
                          <v-autocomplete
                            messages="Busca por código o nombre"
                            :items="distritosItems"
                            v-model="data.addistriId"
                            :filter="distritoFilter"
                            item-text="sadm_addistri_nombre"
                            item-value="sadm_addistri_id"
                            label="Distrito"
                            dense
                            outlined
                            no-data-text="No se encontraron registros."
                            clearable
                            :loader-height="5"
                            :loading="distritosLoading"
                            :disabled="distritosLoading"
                            :rules="noEmptyRules"
                          >
                            <template v-slot:selection="data">
                              <small>
                                {{ data.item.sadm_addistri_nombre }}
                              </small>
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <small class="font-weight-bold">
                                      {{ data.item.sadm_addistri_nombre }}
                                    </small>
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    <small>
                                      <span class="font-weight-bold"
                                        >código:</span
                                      >
                                      {{ data.item.sadm_addistri_codigo }}
                                    </small>
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="colForm">
                          <v-textarea
                            label="Dirección (Línea 1)"
                            required
                            outlined
                            rows="2"
                            v-model="data.estDireccion"
                            :rules="noEmptyRules"
                            no-resize
                            clearable
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="colForm mb-4">
                      <h3 class="my_battery_blue--text">
                        Datos de configuración
                      </h3>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="3">
                          <v-row>
                            <v-col
                              cols="12"
                              class="d-flex align-center justify-center"
                            >
                              <v-img
                                contain
                                max-width="250"
                                :src="logoPreview ? logoPreview : logoDefault"
                                position="center"
                              >
                              </v-img>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                              class="d-flex align-center justify-center"
                            >
                              <v-btn
                                color="primary"
                                elevation="0"
                                @click="handleDialogLogo(true)"
                              >
                                {{
                                  logoPreview
                                    ? "Cambiar logotipo"
                                    : "Cargar logotipo"
                                }}
                              </v-btn>
                              <v-btn
                                v-if="logoPreview"
                                @click="removeLogoInfo"
                                outlined
                                color="primary"
                                elevation="0"
                                class="ml-1"
                              >
                                <v-icon color="primary">
                                  mdi-delete-outline
                                </v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="9">
                          <v-row class="mt-1">
                            <v-col cols="12" sm="6" md="6" class="colForm">
                              <v-text-field
                                readonly
                                label="No.sucursales"
                                required
                                outlined
                                dense
                                background-color="white"
                                v-model="data.estSucursales"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="colForm">
                              <v-select
                                :items="estFormatoExportacionItems"
                                label="Formato de Exportación"
                                item-text="name"
                                item-value="code"
                                outlined
                                dense
                                background-color="white"
                                v-model="data.estFormatoExportacion"
                              ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="colForm">
                              <v-select
                                :items="estFormatoFacturaItems"
                                label="Fomato de factura"
                                item-text="name"
                                item-value="code"
                                outlined
                                dense
                                background-color="white"
                                v-model="data.estFormatoFactura"
                              >
                                <template v-slot:append-outer>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-icon v-on="on">
                                        mdi-help-circle-outline
                                      </v-icon>
                                    </template>
                                    Forma en como se mostrará la factura
                                  </v-tooltip>
                                </template>
                              </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="colForm">
                              <v-select
                                :items="estTipoFacturaItems"
                                label="Tipo Factura"
                                item-text="name"
                                item-value="code"
                                outlined
                                dense
                                background-color="white"
                                v-model="data.estTipoFactura"
                              >
                                <template v-slot:append-outer>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-icon v-on="on">
                                        mdi-help-circle-outline
                                      </v-icon>
                                    </template>
                                    Factura que emitirá el establecimiento
                                  </v-tooltip>
                                </template>
                              </v-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" class="colForm">
                              <v-textarea
                                label="Texto factura cambiaria"
                                required
                                outlined
                                rows="3"
                                v-model="data.estTextoFacturaCambiaria"
                                no-resize
                                clearable
                              ></v-textarea>
                            </v-col>
                            <v-col cols="6" sm="4" md="4" class="colForm">
                              <v-checkbox
                                false-value="No"
                                true-value="Si"
                                v-model="data.estModuloMP"
                                label="Modulo MP"
                              ></v-checkbox>
                            </v-col>
                            <v-col cols="6" sm="4" md="4" class="colForm">
                              <v-checkbox
                                v-model="data.esEstContador"
                                label="Es Contador"
                              ></v-checkbox>
                            </v-col>
                            <v-col cols="6" sm="4" md="4" class="colForm">
                              <v-checkbox
                                v-model="
                                  data.sinvComparteConfiguracionInventario
                                "
                                label="Comparte configuración inventario"
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
              <v-col cols="12" class="px-md-16 d-flex justify-end">
                <v-btn
                  color="primary"
                  elevation="0"
                  @click="save"
                  :disabled="loadingSave"
                  :loading="loadingSave"
                >
                  <v-progress-circular
                    color="white"
                    indeterminate
                    v-if="loadingSave"
                  ></v-progress-circular>
                  <div v-else>
                    <v-icon left dark> mdi-content-save </v-icon>
                    Guardar establecimiento
                  </div>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <dialogo-logo
      v-if="dialogLogo"
      :initialImage="logoPreview"
      @close="dialogLogo = false"
      @handle="handleLogo"
    />
  </div>
</template>

<script>
import MyHeaderView from "@/components/ui/myHeaderView";
import { mapActions, mapState } from "vuex";
import DialogoLogo from "./DialogoLogo.vue";
import { validateCountry } from "@/utils";
export default {
  name: "Main",
  components: { DialogoLogo, MyHeaderView },
  data: () => ({
    showPassword: false,
    data: {
      estRazon: "",
      estNombre: "",
      estSiglas: "",
      estNit: "",
      estDireccion: "",
      paiIso: "",
      creaUsuario: true,
      usuNombre: "",
      usuEmail: "",
      usuPassword: "",
      /* facturaFel: "si",*/
      estProducto: "financiera",
      estFormatoExportacion: "estandard",
      estFormatoFactura: "carta",
      estTipoFactura: "normal",
      estTextoFacturaCambiaria: "",
      estModuloMP: "No",
      sinvComparteConfiguracionInventario: false,
      estSucursales: 1,
      estNrc: "",
      addepId: null,
      admunId: null,
      addistriId: null,
      craecId: null,
      craecId2: null,
      craecId3: null,
      estEmail: "",
      esEstContador: false,
    },
    defaultObject: {
      estRazon: "",
      estNombre: "",
      estSiglas: "",
      estNit: "",
      estDireccion: "",
      paiIso: "",
      creaUsuario: true,
      usuNombre: "",
      usuEmail: "",
      usuPassword: "",
      /*      facturaFel: false,*/
      estProducto: "1",
      estFormatoExportacion: "estandard",
      estFormatoFactura: "carta",
      estTipoFactura: "normal",
      estTextoFacturaCambiaria: "",
      estModuloMP: "No",
      sinvComparteConfiguracionInventario: false,
      estSucursales: 1,
      estNrc: "",
      addepId: null,
      admunId: null,
      addistriId: null,
      craecId: null,
      craecId2: null,
      craecId3: null,
      estEmail: "",
      esEstContador: false,
    },
    emailRules: [
      (value) => !!value || "Campo obligatorio",
      (value) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) ||
        "Ingrese un correo válido",
    ],
    noEmptyRules: [(value) => !!value || "Campo obligatorio"],
    nitRules: [
      (value) => !!value || "Ingrese NIT",
      (value) => /^[\d]+$/.test(value) || "Ingrese un NIT válido, sin guiones",
    ],
    ItemsTipoProducto: [
      { code: "Financiera", name: "Financiera" },
      /*{ code: "comercial", name: "Comercial" },
      { code: "ventas", name: "Ventas" },*/
    ],
    paisItems: [
      { code: "GTM", name: "Guatemala" },
      { code: "SLV", name: "El Salvador" },
      { code: "HND", name: "Honduras" },
      { code: "NIC", name: "Nicaragua" },
      { code: "CRI", name: "Costa Rica" },
      { code: "PAN", name: "Panamá" },
      { code: "COL", name: "Colombia" },
      { code: "ECU", name: "Ecuador" },
    ],
    estFormatoExportacionItems: [
      { code: "estandard", name: "Estándard" },
      /*{ code: "maquila", name: "Máquila" },
      { code: "na", name: "No aplica" },*/
    ],
    estFormatoFacturaItems: [
      { code: "carta", name: "Carta" },
      /*      { code: "ticket", name: "Ticket" },
      { code: "personalizada", name: "estandard" },
      { code: "media carta", name: "Media Carta" },
      { code: "ticket,carta", name: "Ticket y Carta" },
      { code: "ticket, media carta", name: "Ticket y Media Carta" },
      { code: "carta, media carta", name: "Carta y Media Carta" },
      {
        code: "carta, media carta, ticket",
        name: "Carta, Media Carta y Ticket",
      },*/
    ],
    estTipoFacturaItems: [
      { code: "normal", name: "Normal" },
      /*{ code: "cambiaria", name: "Cambiaria" },
      { code: "exportacion", name: "Exportacion" },
      { code: "normal,cambiaria", name: "Normal y Cambiaria" },
      { code: "pequeño contribuyente", name: "Pequeño contribuyente" },*/
    ],
    inProgressSuccess: false,
    dialogLogo: false,
    logo: "", // Base64 de la imagen ya guardada
    logoPreview: "", // url local
    logoDefault: "/img/default-logo.png", // url local
  }),
  computed: {
    ...mapState({
      loadingSave: (state) => state.establecimientos.loadingSave,
      loadingActividadEconomicaItems: (state) =>
        state.catalogs.actividadesEconomicasLoading,
      actividadesEconomicasItems: (state) =>
        state.catalogs.actividadesEconomicas,

      departamentosLoading: (state) => state.catalogs.departamentosLoading,
      departamentosItems: (state) => state.catalogs.departamentos,

      municipiosLoading: (state) => state.catalogs.municipiosLoading,
      municipiosItems: (state) => state.catalogs.municipios,

      distritosLoading: (state) => state.catalogs.distritosLoading,
      distritosItems: (state) => state.catalogs.distritos,
    }),
  },
  mounted: function () {},
  methods: {
    ...mapActions({
      getActividadesEconomicas: "catalogs/getActividadesEconomicas",
      getDepartamentos: "catalogs/getDepartamentos",
      getMunicipios: "catalogs/getMunicipios",
      getDistritos: "catalogs/getDistritos",
    }),

    validateCountry(arr) {
      return validateCountry(this.data.paiIso, arr);
    },
    handleChangePaiIso() {
      this.handleActividadesEconomicas();
      this.resetFormDatosEmpresa();
      this.handleDepartamentos();
    },
    async handleActividadesEconomicas() {
      const data = {
        query: {
          sadm_pai_iso: this.data.paiIso,
        },
      };
      await this.getActividadesEconomicas({ data });
    },
    actividadEconomicaFilter(item, queryText) {
      const codigo = item.scrm_craec_codigo.toLowerCase();
      const abreviatura = item.scrm_craec_abreviatura.toLowerCase();
      const nombre = item.scrm_craec_nombre.toLowerCase();
      const searchText = queryText.toLowerCase();
      return (
        codigo.indexOf(searchText) > -1 ||
        abreviatura.indexOf(searchText) > -1 ||
        nombre.indexOf(searchText) > -1
      );
    },

    resetFormDatosEmpresa() {
      this.data.estNit = "";
      this.data.estRazon = "";
      this.data.estNombre = "";
      this.data.estSiglas = "";
      this.data.estDireccion = "";
      this.data.estProducto = "1";
      this.data.addepId = null;
      this.data.admunId = null;
      this.data.addistriId = null;
      this.data.craecId = null;
      this.data.craecId2 = null;
      this.data.craecId3 = null;
      this.data.estEmail = "";
      this.$refs.form.resetValidation();
    },

    handleChangeDepartamento() {
      this.handleMunicipios();
      this.data.admunId = "";
      this.data.addistriId = "";
      this.$refs.form.resetValidation();
    },
    async handleDepartamentos() {
      const data = {
        query: {
          sadm_pai_iso: this.data.paiIso,
        },
      };
      await this.getDepartamentos({ data });
    },
    departamentoFilter(item, queryText) {
      const codigo = item.sadm_addep_codigo.toLowerCase();
      const nombre = item.sadm_addep_nombre.toLowerCase();
      const searchText = queryText.toLowerCase();
      return codigo.indexOf(searchText) > -1 || nombre.indexOf(searchText) > -1;
    },

    handleChangeMunicipio() {
      this.handleDistritos();
      this.data.addistriId = "";
      this.$refs.form.resetValidation();
    },
    async handleMunicipios() {
      if (this.data.addepId) {
        const data = {
          query: {
            sadm_addep_id: +this.data.addepId,
          },
        };
        await this.getMunicipios({ data });
      }
    },
    municipioFilter(item, queryText) {
      const codigo = item.sadm_admun_codigo.toLowerCase();
      const nombre = item.sadm_admun_nombre.toLowerCase();
      const searchText = queryText.toLowerCase();
      return codigo.indexOf(searchText) > -1 || nombre.indexOf(searchText) > -1;
    },

    async handleDistritos() {
      if (this.data.admunId) {
        const data = {
          query: {
            sadm_admun_id: +this.data.admunId,
          },
        };
        await this.getDistritos({ data });
      }
    },
    distritoFilter(item, queryText) {
      const codigo = item.sadm_addistri_codigo.toLowerCase();
      const nombre = item.sadm_addistri_nombre.toLowerCase();
      const searchText = queryText.toLowerCase();
      return codigo.indexOf(searchText) > -1 || nombre.indexOf(searchText) > -1;
    },

    removeLogoInfo() {
      this.logoPreview = "";
      this.logo = "";
      this.$store.dispatch("alerts/setMessage", {
        message: "Logo descartado.",
        type: "info",
      });
    },
    handleLogo(data) {
      this.logoPreview = data.url; // URL temporal para mostrar vista previa
      this.logo = data.stringBase64; // Imagen en base64 para enviar al backend
      this.dialogLogo = false; // Cierra el diálogo;
    },
    handleDialogLogo(value) {
      this.dialogLogo = value;
    },
    gotoRoute(url) {
      if (url) {
        this.$router.push({ name: url });
        // /back?change=corid
      }
    },
    logout() {
      localStorage.clear();
      window.open(`${process.env.VUE_APP_LOGIN_URL}/logout`, "_self");
    },
    save() {
      if (!this.$refs.form.validate()) return;
      if (!this.logo) {
        this.$store.dispatch("alerts/setMessage", {
          message: "Debes seleccionar un logotipo para este establecimiento.",
          type: "info",
        });
        return;
      }

      const data = {
        ...this.data,
        estSucursales: +this.data.estSucursales,
        logo: this.logo,
        addepId: this.data.addepId ? +this.data.addepId : null,
        admunId: this.data.admunId ? +this.data.admunId : null,
        addistriId: this.data.addistriId ? +this.data.addistriId : null,
        craecId: this.data.craecId ? +this.data.craecId : null,
        craecId2: this.data.craecId2 ? +this.data.craecId2 : null,
        craecId3: this.data.craecId3 ? +this.data.craecId3 : null,
      };

      this.$store.dispatch("establecimientos/createEstablecimiento", {
        data,
      });
      setTimeout(() => {
        this.$toast.success("Establecimiento creado exitosamente.", {
          position: "top-right",
          duration: 3000,
        });
        this.clear();
        this.inProgressSuccess = true;
      }, 3000);
    },
    clear() {
      this.$refs.form.resetValidation();
      this.data = Object.assign({}, this.defaultObject);
    },
  },
};
</script>
<style scoped src="@/assets/css/globals.css"></style>
<style scoped>
.v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}
.required label::after {
  content: "*";
}
.colForm {
  padding-left: 12px !important;
  padding-right: 12px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
</style>
